var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgError = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 12 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E21F11",
  fillRule: "evenodd",
  d: "M12 6A6 6 0 1 1 0 6a6 6 0 0 1 12 0M6 4.586l1.96-1.96A1 1 0 1 1 9.374 4.04L7.414 6l1.96 1.96A1 1 0 1 1 7.96 9.374L6 7.414l-1.96 1.96A1 1 0 1 1 2.626 7.96L4.586 6l-1.96-1.96A1 1 0 1 1 4.04 2.626z",
  clipRule: "evenodd"
})));
export default SvgError;